import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import load from "../Assets/logo/FaamGallery-Page-Loader1-ezgif.com-gif-to-mp4-converter.mp4";
import OrderArtworkItem from "../../Components/OrderItems/OrderArtworkItem";
import OrderFrameItem from "../../Components/OrderItems/OrderFrameItem";
import OrderUserArtworkFrameItem from "../../Components/OrderItems/OrderUserArtworkFrameItem";
import OrderUserArtworkItem from "../../Components/OrderItems/OrderUserArtworkItem";
import OrderArtworkFrameItem from "../../Components/OrderItems/OrderArtworkFrameItem";
import Footer from "../../Components/Layout/Footer";

const Profile = () => {
  const [user, setUser] = React.useState<any>();
  const [errorMessage, setErrorMessage] = React.useState("");
  const [loadin, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const [orders, setOrders] = useState<any>();

  useEffect(() => {
    const currentUser = Parse.User.current();
    const fetchOrders = async () => {
      if (currentUser) {
        console.log(currentUser.get("orders"));
        setUser(currentUser);
        const ordersQuery = new Parse.Query("Order");
        ordersQuery.containedIn("objectId", currentUser.get("orders"));
        try {
          const orderResult = await ordersQuery.find();
          if (orderResult.length > 0) {
            setOrders(orderResult);
            console.log(orderResult);
          }
        } catch (err: any) {
          setErrorMessage(err.message);
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/");
        setErrorMessage("");
      }
    };
    fetchOrders();
  }, []);
  const logoutHandler = () => {
    Parse.User.logOut();
    window.location.reload();
  };
  return (
    <Fragment>
      {user && (
        <Container sx={{ py: 10, mb: 10 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <Box>
              <Typography variant="h6">
                {user.get("firstName")} {user.get("lastName")}
              </Typography>
              <Typography variant="h6">{user.get("username")}</Typography>
            </Box>
            <Box>
              <Link to={"/edit-profile"}>
                <button
                  style={{
                    background: "#aa4b1f",
                    border: "none",
                    outline: "none",
                    color: "white",
                    cursor: "pointer",
                    padding: "10px 15px",
                    borderRadius: "10px",
                    marginRight: 5,
                  }}
                >
                  Edit profile
                </button>
              </Link>
              <button
                style={{
                  background: "#aa4b1f",
                  border: "none",
                  outline: "none",
                  color: "white",
                  cursor: "pointer",
                  padding: "10px 15px",
                  borderRadius: "10px",
                }}
                onClick={logoutHandler}
              >
                logout
              </button>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: 5,
              borderBottom: "2px solid #dad9da",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Order History
            </Typography>
          </Box>
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 400 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order Date</TableCell>
                  <TableCell align="center">Order number</TableCell>
                  <TableCell align="center">Total</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders &&
                  orders.map((order: any) => (
                    <Link to={`/order/${order.id}`}>
                      {" "}
                      <TableRow
                        key={order.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {order.get("createdAt").toDateString()}
                        </TableCell>
                        <TableCell align="center">
                          {order.get("orderNumber")}
                        </TableCell>
                        <TableCell align="center">
                          £{order.get("totalAmount").toFixed(2)}
                        </TableCell>
                        <TableCell align="center">
                          {order.get("status")}
                        </TableCell>
                      </TableRow>
                    </Link>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {!orders && (
            <Typography sx={{ mt: 5, textAlign: "center" }}>
              No orders yet!
            </Typography>
          )}
        </Container>
      )}
    </Fragment>
  );
};

export default Profile;
